export default "__VITE_ASSET__a20bd4ab__"